import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { agregarMensajeTemporizador } from "../../helpers/datos/agregarMensajeTemporizador";
import toTitleCase from "../../helpers/datos/toTitleCase";
import VerificarUsuarioIngresado from "../../helpers/usuario/verificarUsuarioIngresado";

/**
 * Componente que verifica una cuenta y la autoriza (ya existente)
 * @returns Componente de Usuario Login
 */
export default function UsuarioLogin() {
    console.clear();
    VerificarUsuarioIngresado();
    const navigate = useNavigate();
    const [userInput, setUserInput] = useState({ usuario: "", password: "" });
    const [message, setMessage] = useState({ type: null });

    // Ingresar usuario
    const accederUsuario = e => {
        /* e.preventDefault(); */
        if (userInput.usuario === "" && userInput.password === "") {
            setMessage({ type: "error", message: "Campos vacíos" });
            agregarMensajeTemporizador(setMessage);
        }
        else if (userInput.usuario === "") {
            setMessage({ type: "error", message: "Ingrese un usuario" });
            agregarMensajeTemporizador(setMessage);
        }
        else if (userInput.password === "") {
            setMessage({ type: "error", message: "Ingrese una contraseña" });
            agregarMensajeTemporizador(setMessage);
        }
        else {
            fetch("/api/usuario/lista")
                .then(response => {
                    if (response.ok) return response.json();
                })
                .then(usuariosData => {
                    const usuarios = usuariosData.data.map(usuario => usuario.login);

                    // Verifica si existe algún usuario con ese nombre
                    if (usuarios.includes(userInput.usuario)) {
                        fetch("/api/usuario/login", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            credentials: "include",
                            body: JSON.stringify({ "Login": userInput.usuario, "Password": userInput.password })
                        })
                            .then((responseLogin) => responseLogin.json())
                            .then(dataLogin => {
                                if (dataLogin.status === "FAIL") {
                                    setMessage({ type: "error", message: dataLogin.message });
                                    agregarMensajeTemporizador(setMessage);
                                    setUserInput({ usuario: "", password: "" });
                                }
                                else fetch("/api/usuario/usuario", {
                                    headers: { "Content-Type": "application/json" },
                                    credentials: "include"
                                })
                                    .then(responseUsuario => {
                                        if (responseUsuario.ok) return responseUsuario.json();
                                    })
                                    .then(data => {
                                        if (data.status === "OK") {
                                            const { password: _, ...usuarioFinal } = data.data;
                                            localStorage.setItem("usuario", JSON.stringify(usuarioFinal));
                                            navigate("/contacto/contacto");
                                        }
                                    })
                                    .catch(() => navigate("/admin/login"))
                            })
                            .catch(() => navigate("/admin/login"));
                    }
                    else {
                        setMessage({ type: "error", message: "Usuario inválido" });
                        agregarMensajeTemporizador(setMessage);
                        setUserInput({ usuario: "", password: "" });
                    }
                })
        }
    }

    useEffect(() => { }, [userInput, message]);

    return (
        <div>
            <div className="overlay">
                <div className="form_login">
                    <div className="boxColumn">
                        <div className="boxColumn center cabecera">
                            <h1>MOVILIDAD</h1>
                            <h2>{message.type !== "error" ? "Ordenes de Pago" : toTitleCase(message.message)}</h2>
                        </div>

                        {/* Usuario */}
                        <div className="boxColumn marginTop10 padding30" onKeyDown={e => e.key === "Enter" && accederUsuario()}>
                            <label className="lblCampo">Usuario</label>
                            <div className="search-bar">
                                <div className="actions noActions">
                                    <button><span className="material-icons">person</span></button>
                                </div>
                                <input className="iconLeft" type="text"
                                    value={userInput.usuario ?? ""}
                                    onChange={e => setUserInput({ ...userInput, usuario: e.target.value.trim() })} />
                            </div>
                        </div>

                        {/* Contraseña */}
                        <div className="boxColumn marginTop10 padding30" onKeyDown={e => e.key === "Enter" && accederUsuario()}>
                            <label className="lblCampo" >Contraseña</label>
                            <div className="search-bar">
                                <div className="actions noActions">
                                    <button><span className="material-icons">key</span></button>
                                </div>
                                <input className="iconLeft" type="password"
                                    value={userInput.password ?? ""}
                                    onChange={e => setUserInput({ ...userInput, password: e.target.value.trim() })}
                                />
                            </div>
                        </div>

                        <div className="boxColumn marginTop30 center">
                            <button className="button" onClick={accederUsuario}><span>Ingresar</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

